import { render, staticRenderFns } from "./newsdetail.vue?vue&type=template&id=341f8cf5&scoped=true&"
import script from "./newsdetail.vue?vue&type=script&lang=js&"
export * from "./newsdetail.vue?vue&type=script&lang=js&"
import style0 from "./newsdetail.vue?vue&type=style&index=0&id=341f8cf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341f8cf5",
  null
  
)

export default component.exports